import { useSnackbar } from "notistack";
import React, { useState } from "react";
import { ApiRequestPost } from "../../../../../../data/network/services/ApiRequestPost";
import {
  bulkBeneficiaryFirstHeader,
  bulkBeneficiaryMainHeader,
  bulkDataModifierForBeneficiary,
  totalAmountCalculator,
} from "../../../../../../utility/bulkDataModifier";
import { numberWithCommas } from "../../../../../../utility/commaSeperator";
import ResizeListener from "../../../../../../utility/ResizeListener";
import CustomModal from "../../../../../components/customModal/CustomModal";
import { WHITE_COLOR } from "../../../../../resources/colorsManager";
import { SUCCESS } from "../../../../../resources/constantsManager";
import AddCustomerBulk from "../../../add_customer/bulk/AddCustomerBulk";
import DisplayBulk from "../../../add_customer/bulk/DisplayBulk";
import BeneficiarySendOtp from "../individual/BeneficiarySendOtp";
import { saveAs } from "file-saver";
import beneficiaryBulk from "../../../../../../sample/Beneficiary Bulk Upload Sample.csv";
function AddBeneficiaryBulk({ onSuccess }) {
  const { width, height } = ResizeListener();

  const { enqueueSnackbar } = useSnackbar();
  const [step, setStep] = useState(0);
  const [showPreiveiewModal, setShowPreiveViewModal] = useState(false);
  const [bulkData, setBulkData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [openOtpModal, setOpenOtpMpdal] = useState(false);

  const verifyOtp = (otp) => {
    setLoading(true);
    ApiRequestPost.verifyOtpForBeneficiary({
      otp,
    })
      .then((response) => {
        if (response.status === SUCCESS) {
          onClickSubmitBulk();
        } else {
          enqueueSnackbar(response.message, {
            variant: "error",
          });
        }
      })
      .catch((error) => {
        enqueueSnackbar(error.message, {
          variant: "error",
        });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const sendOtp = (amount) => {
    setLoading(true);
    ApiRequestPost.sendOtpForBeneficiary({
      amount,
    })
      .then((response) => {
        if (response.status === SUCCESS) {
          setOpenOtpMpdal(true);
          enqueueSnackbar(response.message, {
            variant: "success",
          });
        } else {
          enqueueSnackbar(response.message, {
            variant: "error",
          });
        }
      })
      .catch((error) => {
        enqueueSnackbar(error.message, {
          variant: "error",
        });
      })
      .finally(() => {
        setLoading(false);
      });
  };
  const onClickSubmitBulk = () => {
    setLoading(true);
    ApiRequestPost.beneficiaryBulkUpload({
      groupBeneficiaryRequestList: bulkData,
    })
      .then((response) => {
        if (response.status === SUCCESS) {
          enqueueSnackbar("Beneficiary added successfully", {
            variant: "success",
          });
          setOpenOtpMpdal(false);
          onSuccess();
        } else {
          enqueueSnackbar(response.message, {
            variant: "error",
          });
          onSuccess();
        }
        console.log(response);
        setLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
      });
  };
  return (
    <div>
      <AddCustomerBulk
        passRawData={(val) => {
          let data = val.data;

          // const firstRow = data[0]?.every((val) => {
          //   if (val !== "")
          //     return bulkBeneficiaryFirstHeader.includes(val?.toLowerCase());
          //   else return true;
          // });
          const secondRow0 = data[0]?.every((val) => {
            if (val !== "")
              return bulkBeneficiaryMainHeader.includes(val?.toLowerCase());
            else return true;
          });

          const secondRow1 = data[1]?.every((val) => {
            if (val !== "")
              return bulkBeneficiaryMainHeader.includes(val?.toLowerCase());
            else return true;
          });

          console.log(data, "datadata");

          if (secondRow0) {
            setBulkData(
              bulkDataModifierForBeneficiary(data?.slice(1, data.length))
            );
            setStep(1);
          } else if (secondRow1) {
            setBulkData(
              bulkDataModifierForBeneficiary(data?.slice(2, data.length))
            );
            setStep(1);
          } else {
            enqueueSnackbar(
              "Invalid headers, please do not change the headers given in the sample template",
              {
                variant: "error",
              }
            );
          }
        }}
        step={step}
        onClickSubmit={() => {
          if (bulkData.length > 0) setShowPreiveViewModal(true);
          else {
            enqueueSnackbar(
              "Please validate data in the sheet before uploading.",
              {
                variant: "error",
              }
            );
          }
        }}
        onClickClear={() => {
          setStep(0);
        }}
        onClickDownloadSample={() => {
          saveAs(beneficiaryBulk, "beneficiary bulk sample");
        }}
      />

      {showPreiveiewModal && (
        <CustomModal
          open={showPreiveiewModal}
          onClose={() => {
            setShowPreiveViewModal(false);
          }}
        >
          <DisplayBulk
            data={bulkData}
            onClickSubmit={(data) => {
              sendOtp(totalAmountCalculator(data));
            }}
            loading={loading}
          />
        </CustomModal>
      )}

      {openOtpModal && (
        <CustomModal
          open={openOtpModal}
          onClose={() => {
            setOpenOtpMpdal(false);
          }}
        >
          <div
            style={{
              width: "100%",
              display: "flex",
              flexDirection: "column",
              marginTop: 20,
              padding: "20px 30px",
              backgroundColor: WHITE_COLOR,
              minWidth: 400,
              borderRadius: 30,
              width: width * 0.35,
              height: "100%",
              // alignItems: "center",'
              paddingBottom: 20,
              maxWidth: 400,
            }}
          >
            <BeneficiarySendOtp
              onClickConfirm={(otp) => {
                verifyOtp(otp);
              }}
              loading={loading}
            />
          </div>
        </CustomModal>
      )}
    </div>
  );
}

export default AddBeneficiaryBulk;
